/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import "../App.scss";
import { useDispatch, useSelector } from "react-redux";
import { toggleAuth } from "../Redux/Slices/auth-slice";
import { fetchApi } from "../utlis/axios";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "../dashboard/admin/_adminApi";
import { toast } from "react-toastify";
import { handleRole } from "../constent/helper";

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { isLogin, userInfo } = useSelector((state) => state?.auth || {});
  const [formValues, setFormValues] = useState({ email: "", password: "" });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!formValues?.email || !formValues?.password)
      return toast.error("All fields are required!");
    setLoading(true);
    try {
      const result = await fetchApi.post("login/", formValues);
      if (result?.data) {
        // login/ doesn't return the Django admin flags. A failure here must not
        // block sign-in: the user just falls back to role-based routing.
        const flags = await fetchApi
          .get("admin/me/", { headers: { Authorization: `Bearer ${result.data.access}` } })
          .then((r) => ({ is_staff: !!r?.data?.is_staff, is_superuser: !!r?.data?.is_superuser }))
          .catch(() => ({}));
        dispatch(toggleAuth({
          isLogin: true,
          userInfo: { ...result.data, user: { ...result.data.user, ...flags } },
        }));
        setLoading(false);
        handleRole(result?.data?.user?.role, navigate, flags);
      } else {
        setError("Given credentials are wrong");
      }
    } catch (error) {
      setError(
        error?.response?.status === 401
          ? "Incorrect email or password."
          : "Could not sign in. Check your connection and try again."
      );
      console.error(error);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    if (isLogin) handleRole(userInfo?.user?.role, navigate);
  }, [isLogin]);

  return (
    <div className="kw-auth">
      <aside className="kw-auth-aside">
        <Link to="/" className="site-brand">
          <span className="site-brand-mark"><Icon.cross /></span>
          <span>
            <strong>KWF</strong>
            <span className="t">Khadim Welfare Foundation</span>
          </span>
        </Link>
        <div className="kw-auth-copy">
          <h1>Serving families across Pakistan</h1>
          <p>Sign in to manage applications, programs, donations and medical stores in one place.</p>
        </div>
      </aside>
      <main className="kw-auth-main">
        <div className="kw-auth-card">
          <h2>Sign in</h2>
          <p>Use your KWF account email and password.</p>
          <form onSubmit={handleLogin}>
            <label htmlFor="login-email">Email address</label>
            <input
              id="login-email"
              type="email"
              autoComplete="email"
              autoFocus
              required
              className="form-control"
              value={formValues?.email}
              onChange={(e) => setFormValues({ ...formValues, email: e?.target?.value })}
            />
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              autoComplete="current-password"
              required
              className="form-control"
              value={formValues?.password}
              onChange={(e) => setFormValues({ ...formValues, password: e?.target?.value })}
            />
            {error && <div className="kw-auth-err" role="alert">{error}</div>}
            <button type="submit" name="login" id="login" className="primary-button !w-full" disabled={loading}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <Link to="/" className="kw-auth-back">← Back to website</Link>
        </div>
      </main>
    </div>
  );
};
